import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { requestPayoutFailure, requestPayoutSuccess } from '../../actions/InfluencerCampaignActions/requestPayoutAction';

function* requestPayout({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.requestPayout,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("REQUEST_PAYOUT_SUCCESS status :", response.data.status);
        console.log("REQUEST_PAYOUT_SUCCESS data :", response.data.response);
        console.log("REQUEST_PAYOUT_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            requestPayoutSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("REQUEST_PAYOUT_FAILURE status :", error?.response?.status);
        console.log("REQUEST_PAYOUT_FAILURE data:", error?.response?.data);
        console.log("REQUEST_PAYOUT_FAILURE error :", error);
        console.log('====================================');
        yield put(requestPayoutFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* requestPayoutSaga() {
    yield takeLatest(actionTypes.REQUEST_PAYOUT_REQUEST, requestPayout);
}

export default requestPayoutSaga;
